<h1 mat-dialog-title>Processing data...</h1>
<div mat-dialog-content>

  <p *ngIf="loaded; else loading">
    Done!
  </p>
  <ng-template #loading>
      <p>It can take up to a minute</p>
  </ng-template>

  <mat-progress-bar *ngIf="final" mode="indeterminate"></mat-progress-bar>
  <mat-progress-bar *ngIf="!final" mode="determinate" value="{{ progress$ | async }}"></mat-progress-bar>
</div>